import { render, staticRenderFns } from "./add-moderator.vue?vue&type=template&id=4ddb1798&"
import script from "./add-moderator.ts?vue&type=script&lang=ts&"
export * from "./add-moderator.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports